import React from "react";
import ImageGallery from "../components/ImageGallery";

function GalleryOne() {
  return (
    <div>
      <div className="gallery">
        <ImageGallery />
      </div>
    </div>
  );
}

export default GalleryOne;
